import React, { createContext, useContext, useEffect, useState } from 'react'
import {
  DEFAULT_OPEN_DAYS,
  DEFAULT_ONLINE_ORDER_DAYS
} from '../utils/openingHours'

const AnnouncementContext = createContext(null)

const API_BASE = process.env.REACT_APP_API_URL ?? ''

export const AnnouncementProvider = ({ children }) => {
  const [announcement, setAnnouncement] = useState(null)
  const [openDays, setOpenDays] = useState(DEFAULT_OPEN_DAYS)
  const [onlineOrderDays, setOnlineOrderDays] = useState(DEFAULT_ONLINE_ORDER_DAYS)

  const [openingHours, setOpeningHours] = useState(null)
  const [onlineOrderHours, setOnlineOrderHours] = useState(null)

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/menu`)
        if (!res.ok) throw new Error('API error')

        const data = await res.json()

        setAnnouncement(data.announcement || null)

        if (Array.isArray(data.openDays)) {
          setOpenDays(data.openDays)
        }

        if (Array.isArray(data.onlineOrderDays)) {
          setOnlineOrderDays(data.onlineOrderDays)
        }

        setOpeningHours(data.openingHours ?? null)
        setOnlineOrderHours(data.onlineOrderHours ?? null)

      } catch (err) {
        setAnnouncement(null)
        setOpenDays(DEFAULT_OPEN_DAYS)
        setOnlineOrderDays(DEFAULT_ONLINE_ORDER_DAYS)
        setOpeningHours(null)
        setOnlineOrderHours(null)
      }
    }

    fetchAnnouncement()
  }, [])

  const announcementActive =
    !!(announcement?.active && announcement?.message)

  return (
  <AnnouncementContext.Provider
    value={{
      announcement,
      announcementActive,

      openDays,
      setOpenDays,

      onlineOrderDays,
      setOnlineOrderDays,

      openingHours,
      setOpeningHours,

      onlineOrderHours,
      setOnlineOrderHours,
    }}
  >
    {children}
  </AnnouncementContext.Provider>
)
}

export const useAnnouncement = () => {
  const ctx = useContext(AnnouncementContext)
  if (!ctx) {
    throw new Error('useAnnouncement must be used within AnnouncementProvider')
  }
  return ctx
}